import { useParams } from 'react-router-dom';

import { AxiosResponse } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { usePermissionsContext } from 'context/PermissionsContext';
import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useColunasDinamicasContext } from 'pages/cadastro/colunas-dinamicas/contexts/ColunasDinamicasContext';
import { ColunaDinamicaProps } from 'pages/cadastro/loja/types';

export function useMutateColunasDinamicas() {
    const { mutate, isLoading } = useFormMutation<AxiosResponse<ColunaDinamicaProps[]>>();
    const { showError } = useShowError();
    const { id } = useParams();
    const { hasPermission } = usePermissionsContext();
    const { setOpenModalColunasDinamicas } = useColunasDinamicasContext();

    let url = '/gestao/lojaconfiguracao/list';

    const onSubmitForm = (formData: ColunaDinamicaProps[] | undefined) => {
        if (id) {
            url = `${url}/${id}`;
        }
        mutate(
            {
                url,
                formData: formData,
                method: 'POST',
                preventSnack: true,
                preventRedirect: !!hasPermission(['SECAO_DADOS_ALTERAR']),
            },
            {
                onSuccess: () => {
                    enqueueSnackbar('Coluna salva com sucesso', { variant: 'success' });
                    url = '/gestao/lojaconfiguracao/list';
                },
                onError: (error: any) => {
                    showError(error, 'Erro ao salvar coluna');
                    setOpenModalColunasDinamicas(true);
                },
            },
        );
    };

    return { onSubmitForm, isLoading };
}
